import { useState } from "react";
import FileUpload from "./FileUpload";
import VideoTrimmer from "./VideoTrimmer";

export default function UploadPage() {
  const [videoFile, setVideoFile] = useState<File | null>(null);

  const handleVideoUpload = (file: File) => {
    setVideoFile(file);
  };

  return (
    <div className="p-4 space-y-6">
      <FileUpload onVideoUpload={handleVideoUpload} />

      {videoFile && (
        <div className="border rounded-lg p-4">
          <VideoTrimmer file={videoFile} />
        </div>
      )}
    </div>
  );
}

